import { render, staticRenderFns } from "./TableTypeModal.vue?vue&type=template&id=a97b678c&scoped=true"
import script from "./TableTypeModal.vue?vue&type=script&lang=js"
export * from "./TableTypeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97b678c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a97b678c')) {
      api.createRecord('a97b678c', component.options)
    } else {
      api.reload('a97b678c', component.options)
    }
    module.hot.accept("./TableTypeModal.vue?vue&type=template&id=a97b678c&scoped=true", function () {
      api.rerender('a97b678c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/dining/table/TableTypeModal.vue"
export default component.exports